import React from 'react';
import { useSelector } from 'react-redux';
import { css } from '@/styled-system/css';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import { Module } from '../../../ui/Module/Module';
import { ExpiredListingBanner } from '../ExpiredListingBanner';
import { moduleConfig } from '../moduleConfig';

const moduleRendererContainer = css({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '100%',
});

export const ModuleRenderer = () => {
  const currentListing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);
  const clientLoaded = useSelector((state: RootReduxState) => state.app?.clientLoaded ?? false);
  const isListingActive = currentListing?.active !== false;

  return (
    // `data-module-list` is the structural hook used by HaloListingPage's
    // `summaryRow` style to collapse the first module's top padding on
    // mobile (see `&[data-summary-row] + [data-module-list] > article:first-of-type`).
    // The collapse still depends on `<Module>` rendering its content inside
    // an `<article>`; if that changes, update haloListingPage.styles.tsx.
    <div data-module-list="" className={moduleRendererContainer}>
      {!isListingActive && <ExpiredListingBanner />}
      {moduleConfig
        .filter((module) => module.enabled !== false)
        .filter((module) => !module.requiresClientLoaded || clientLoaded)
        .filter((module) => !module.shouldRender || module.shouldRender(currentListing))
        .map((module) => {
          const Component = module.component;

          return (
            <Module key={module.type} title={module.title} id={module.id}>
              <Component />
            </Module>
          );
        })}
    </div>
  );
};
